/** Service for Task Monitor API — GET /api/v1/admin/task-monitor */

import type { TaskMonitorResponse } from '../types/taskMonitor';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8001';

function getToken(): string | null {
  return localStorage.getItem('token');
}

function authHeaders(): Record<string, string> {
  const token = getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export async function getTaskMonitor(): Promise<TaskMonitorResponse> {
  const response = await fetch(`${API_URL}/api/v1/admin/task-monitor`, {
    headers: { 'Content-Type': 'application/json', ...authHeaders() },
  });
  if (!response.ok) {
    throw new Error(`Task monitor request failed: ${response.status}`);
  }
  return response.json();
}

export async function dismissProviderError(provider: string): Promise<void> {
  const response = await fetch(
    `${API_URL}/api/v1/admin/task-monitor/provider-error/${encodeURIComponent(provider)}`,
    { method: 'DELETE', headers: authHeaders() },
  );
  if (!response.ok && response.status !== 404) {
    throw new Error(`Failed to dismiss provider error: ${response.status}`);
  }
}
